<template>
  <div id="app" :style="{ fontFamily: fonts }" :class="{ rtl,hasPlayList:setting&&setting.multiple,
   ['skin-' + skin]: 1, ['btnSkin-' + btnSkin]: 1,
  'player-status-error':playerError,
  'player-status-loading':playerLoading,
  'player-status-playing':playerPlaying,
  'player-status-pause':!playerPlaying,
  'player-status-loaded':playerLoaded,
  'mini-player':mini,
  'player-disabled-wave':!episode || !episode.enableWave
  }">
    <link rel="stylesheet" v-if="customCssLink && !css2" :href="getCustomCssLink()" type="text/css">
    <div style="display:none" v-if="css2" v-html='css2'></div>
    <div v-if="error">
      <div v-if="errorLogo && errorLoginUrl">
        <div v-if="square===1" class="row square-need-login common-need-login">
          <div class="episode-logo p-0">
              <img :src="errorLogo" alt="Episode logo" />
          </div>
          <div class="main col min-w-0 p-0 classic-text">
            <p>To access this internal podcast,<br> please login first.</p>
            <a class="btn" href="javascript:;" @click="openLoginWindow">Login</a>
          </div>
        </div>
        <div v-else class="row classic-need-login common-need-login">
          <div class="episode-logo col-auto p-0">
              <img :src="errorLogo" alt="Episode logo" />
          </div>
          <div class="main col min-w-0 p-0 classic-text">
            <p>To access this internal podcast,<br> please login first.</p>
            <a class="btn" href="javascript:;" @click="openLoginWindow">Login</a>
          </div>
        </div>
      </div>
      <div v-else class="error player-error">
        <svg t="1614910586035" class="icon" fill="currentColor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17382"><path d="M512 981.333333c259.2 0 469.333333-210.133333 469.333333-469.333333S771.2 42.666667 512 42.666667 42.666667 252.8 42.666667 512s210.133333 469.333333 469.333333 469.333333z m0 42.666667C229.226667 1024 0 794.773333 0 512S229.226667 0 512 0s512 229.226667 512 512-229.226667 512-512 512z" p-id="17383"></path><path d="M706.88 724.266667a21.333333 21.333333 0 1 1-31.616 28.629333A212.992 212.992 0 0 0 516.736 682.666667a213.44 213.44 0 0 0-126.890667 41.6 21.333333 21.333333 0 0 1-25.322666-34.325334A256.085333 256.085333 0 0 1 516.714667 640a255.637333 255.637333 0 0 1 190.165333 84.266667zM330.346667 424.533333l-60.330667 60.330667a21.333333 21.333333 0 0 1-30.165333-30.165333l60.330666-60.352-60.330666-60.330667a21.333333 21.333333 0 0 1 30.165333-30.165333l60.330667 60.330666 60.352-60.330666a21.333333 21.333333 0 1 1 30.165333 30.165333l-60.352 60.330667 60.352 60.352a21.333333 21.333333 0 1 1-30.165333 30.165333l-60.352-60.352zM693.013333 424.533333l-60.330666 60.330667a21.333333 21.333333 0 0 1-30.165334-30.165333l60.330667-60.352-60.330667-60.330667a21.333333 21.333333 0 1 1 30.165334-30.165333l60.330666 60.330666 60.352-60.330666a21.333333 21.333333 0 1 1 30.165334 30.165333l-60.352 60.330667 60.352 60.352a21.333333 21.333333 0 1 1-30.165334 30.165333l-60.352-60.352z" p-id="17384"></path></svg>
        <div class="text">{{ error }}</div>
      </div>
    </div>
    <template v-else-if="setting">
      <template v-if="$store.state.episodes.length > 0">
        <template v-if="episode.type === 'audio'">
          <audio-player-mini
            v-if="mini !== 0"
          ></audio-player-mini>
          <audio-player
            v-else-if="square === 0"
          ></audio-player>
          <audio-player-square
            v-else-if="square !== 0"
          ></audio-player-square>
        </template>

        <video-player v-if="episode.type === 'video'"></video-player>
        <playlist v-if="setting.multiple"></playlist>
      </template>
      <template v-else>
        <img style="width: 100%;" :src="$store.state.screenshotImg"/>
      </template>
    </template>

    <div style="display: none">version: 20230927</div>
  </div>
</template>

<script>
import AudioPlayer from "@/components/AudioPlayer";
import AudioPlayerSquare from "@/components/AudioPlayerSquare";
import VideoPlayer from "@/components/VideoPlayer";
import {ACTION_INIT_PLAYER} from "@/store/actions";
import {mapGetters, mapState} from "vuex";
import Playlist from "@/components/Playlist";
import AudioPlayerMini from "@/components/AudioPlayerMini";
import {isIE, openConnectWindow} from "./common/utils";

export default {
  name: "App",
  components: { AudioPlayerMini, Playlist, VideoPlayer, AudioPlayerSquare, AudioPlayer },

  data() {
    return {
      loadingFinished: false,
      styleCSS: ".min-w-0 {min-width: 0;}.pb-audio-player{background-color: var(--player-color);}.video-js {.vjs-time-control {span {color: var(--font-color) !important;opacity: 0.5;}}}.player-double-speed {button {svg {path {fill: var(--font-color);opacity: 0.5;}}}.double-speed {color: var(--font-color);}}.pb-actions {a , a:hover{color: var(--font-color);}}.top-title-logo {.pb-brand-small-logo {a{.icon-podbean-logo{color:var(--font-color)!important;opacity:0.8;}} }}.episode-name, .channel-name {color: var(--font-color);}.episode-name a,.channel-name a {color: var(--font-color);}.episode-name a:hover, .channel-name a:hover {color: var(--font-color);}.vjs-play-control {color: var(--player-btn-color);}.vjs-big-play-button {border: 0.06666em solid var(--player-btn-color) !important;}.pb-video-player {.vjs-icon-placeholder {&:before {color: var(--player-btn-color);}}}.player-loading {.item {background: var(--player-btn-color) !important;}}.vjs-play-control, .vjs-progress-control .vjs-play-progress, .top-line {background-color: var(--player-btn-color) !important;}.vjs-load-progress {div {background: var(--player-btn-color) !important;opacity: 0.25;}}.player-list {li.active {.episode-title, .play-icon, .bi-pause-fill {color: var(--player-btn-color) !important;}}li {&:hover {.episode-title, .play-icon, .bi-pause-fill {color: var(--player-btn-color) !important;}}}}",
    };
  },
  computed: {
    ...mapState([
        "setting",
        "square",
        "mini",
        "error",
        "rtl",
        "fonts",
        "skin",
        "btnSkin",
      "playerError",
      "playerLoading",
      "playerLoaded",
      "playerPlaying",
      "playerColor",
      "playerBtnColor",
      "fontColor",
        "errorLogo",
        "errorLoginUrl",
        "customCssLink",
        "customCss",
        "cssVersion",
        "showFullScreenToggle"
    ]),
    ...mapGetters(["episode"]),
    css2() {
      return  this.customCss !==null ? `<style>${this.customCss}</style>` : ``;
    }
  },
  async mounted() {
    this.$store.dispatch(ACTION_INIT_PLAYER);
  },
  watch: {
    playerColor() {
      if(this.playerColor){
        let r = document.querySelector(':root');
        r.style.setProperty('--player-color', this.playerColor);
        this.initStyle();
      }
    },
    playerBtnColor() {
      if(this.playerBtnColor){
        let r = document.querySelector(':root');
        r.style.setProperty('--player-btn-color', this.playerBtnColor);
        this.initStyle();
      }
    },
    fontColor() {
      if(this.fontColor){
        let r = document.querySelector(':root');
        r.style.setProperty('--font-color', this.fontColor);
        this.initStyle();
      }
    }
  },
  methods: {
    initStyle() {
      if(isIE()){
        let style = document.createElement("style");
        let styleCss = this.styleCSS;
        styleCss = styleCss.replace(/var\(--font-color\)/g, this.fontColor)
            .replace(/var\(--player-btn-color\)/g, this.playerBtnColor)
            .replace(/var\(--player-color\)/g, this.playerColor)
        styleCss += ".pb-actio" +
            "" +
            "" +
            "" +
            "" +
            "ns a, .pb-actions a:hover{color: "+this.fontColor+" !important;}"
        styleCss += ".vjs-text-track-cue div{color: "+this.fontColor+" !important;}"
        style.innerText = styleCss
        let head = document.getElementsByTagName("head")[0];
        head.appendChild(style);
      }
    },
    openLoginWindow(){
      window.reloginFinished = function (){
         window.location.reload();
      };
      openConnectWindow(this.errorLoginUrl)
    },
    getCustomCssLink(){
      return this.customCssLink+'?v='+this.cssVersion
    }
  }
};
</script>

<style lang="scss">
.player-error{
  background: #f9f9f9;
  padding: 10px;
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  min-height: 100%;
  justify-content: center;
  svg{
    width: 46px;
    min-width: 46px;
    height: 46px;
    min-height: 46px;
    color: #a9a9a9;
  }
  .text{
    font-size: 14px;
    padding-top: 8px;
  }
}
@import "common/scss/common";
:root{
  --player-color: #f6f6f6;
  --player-btn-color: #1b1b1b;
  --font-color: #1a1a1a;
}

.min-w-0 {
  min-width: 0;
}


.pb-audio-player{
  background-color: var(--player-color);
}

.vjs-text-track-cue{
  div{
    color: var(--font-color) !important;
  }
}

.video-js {
  .vjs-time-control {
    span {
      color: var(--font-color) !important;
      opacity: 0.5;
    }
  }
}

.player-double-speed {
  button {
    svg {
      path {
        fill: var(--font-color);
        opacity: 0.5;
      }
    }
  }

  .double-speed {
    color: var(--font-color);
  }
}

.pb-actions {
  a , a:hover{
    color: var(--font-color);
  }
}

.top-title-logo {
  .pb-brand-small-logo {
    a {
      .icon-podbean-logo {
        color: var(--font-color) !important;
        opacity: 0.8;
      }
    }
  }
}

.episode-name, .channel-name {
  color: var(--font-color);
}

.episode-name a,
.channel-name a {
  color: var(--font-color);
}

.episode-name a:hover, .channel-name a:hover {
  color: var(--font-color);
}

.vjs-play-control {
  color: var(--player-btn-color);
}

.vjs-big-play-button {
  border: 0.06666em solid var(--player-btn-color) !important;
}

.pb-video-player {
  .vjs-icon-placeholder {
    &:before {
      color: var(--player-btn-color);
    }
  }
}

.player-loading {
  .item {
    background: var(--player-btn-color) !important;
  }
}

.vjs-play-control, .vjs-progress-control .vjs-play-progress, .top-line {
  background-color: var(--player-btn-color) !important;
}

.vjs-load-progress {
  div {
    background: var(--player-btn-color) !important;
    opacity: 0.25;
  }
}

.player-list {
  li.active {
    .episode-title, .play-icon, .bi-pause-fill {
      color: var(--player-btn-color) !important;
    }
  }

  li {
    &:hover {
      .episode-title, .play-icon, .bi-pause-fill {
        color: var(--player-btn-color) !important;
      }
    }
  }
}

.common-need-login{
    margin: 0 !important;
   .classic-text{
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .pb-link{
      color: #7cc600;
      text-decoration: underline;
    }
    p{
      text-align: center;
    }
    .btn{
      background-color: #7cc600;
      color: #fff;
      padding: 6px 32px;
      border-radius: 6px;
      text-decoration: none;
      &:hover,&:focus{
        opacity: 0.88;
      }
    }
  }
}

.classic-need-login{
  border: 1px solid #dedede;
  height: 150px;
  max-height: 150px;
  border-radius: 5px;
  flex-shrink: 0;
  transition: all .2s;
  position: relative;
  width: 100%;
  background-color: #f6f6f6;
  .episode-logo{
    img{
      width: 148px;
      height: 148px;
      min-width: 148px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
}

#app{
  &>div{
    height: 100%;
    &>div{
      height: 100%;
    }
  }
  .square-need-login{
    height: 100%;
    background-color: #f6f6f6;
    border: 1px solid #dedede;
    position: relative;
    .episode-logo{
      width: 100%;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .classic-text{
      position: absolute;
      background: rgba(0,0,0,0.6);
      height: 100%;
      p{
        color: #ffffff;
      }
    }
  }
}




</style>
